import domReady from '@wordpress/dom-ready';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

domReady(() => {
	const headerMenu = document.querySelector('.header-menu');
	if (headerMenu) {
		const headerMenuItems =
			headerMenu.querySelectorAll('.header-menu-item');

		if (headerMenuItems && headerMenuItems.length) {
			headerMenuItems.forEach((block) => {
				const headerMenuItemLink = block.querySelector(
					'a.header-menu-item-inner'
				);
				if (headerMenuItemLink) {
					const headerMenuItemHref = headerMenuItemLink
						.getAttribute('href')
						.replace(/\/$/, '');

					if (
						headerMenuItemHref ==
						window.location.href.replace(/\/$/, '')
					) {
						block.classList.add('current-menu-item');
					}
				}
			});
		}
	}
});
